import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerOverlay,
  DrawerPortal,
  DrawerTitle,
  DrawerTrigger,
} from "@repo/ui/components/ui/drawer";
import Icon from "@repo/ui/components/ui/icon/icon";
import { Button } from "@repo/ui/components/ui/button";

interface DrawerSidebarProps {
  labels: {
    trigger: string;
    title: string;
    clear: string;
    submit: string;
  };
  actions: {
    clear: () => void;
    submit: () => void;
  };
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  itemsNumber?: number;
  children?: React.ReactNode;
}

export default function DrawerSidebar({
  labels,
  actions,
  children,
  drawerOpen,
  setDrawerOpen,
  itemsNumber,
}: DrawerSidebarProps) {
  return (
    <Drawer onOpenChange={setDrawerOpen} open={drawerOpen} direction="left">
      <DrawerTrigger asChild>
        <button className="text-xl leading-none underline flex gap-[10px] items-center">
          {labels.trigger}
          <Icon
            className="h-[24px] w-[24px] p-[1px] rounded-full bg-primary-magenta"
            icon="Filters2"
          />
        </button>
      </DrawerTrigger>
      <DrawerPortal>
        <DrawerOverlay className="fixed inset-0 bg-black/50" />
        <DrawerContent className="z-50 text-primary-black left-0 h-full w-[500px] max-md:w-full pb-10">
          <div className="bg-primary-white relative h-full light overflow-y-scroll">
            <div className="bg-primary-white w-full px-10 max-md:px-4 py-5 z-50 flex justify-between items-center fixed top-0">
              <DrawerTitle className="font-semibold text-[30px] max-md:text-[24px]">
                {labels.title}
              </DrawerTitle>
              <DrawerTrigger className="flex justify-end">
                <Icon
                  icon="Close"
                  className="h-[40px] w-[40px] max-md:h-[30px] max-md:w-[30px]"
                />
              </DrawerTrigger>
            </div>
            <section className="all-uppercase">{children}</section>
          </div>
          <DrawerFooter className="drop-shadow-header bg-primary-white fixed bottom-0 w-full light grid grid-cols-2 gap-4 max-md:gap-2 px-10 max-md:px-4 z-50">
            <Button
              onClick={actions.clear}
              className="flex-1 max-md:text-[16px]"
              variant="outline"
            >
              {labels.clear}
            </Button>
            <Button
              onClick={actions.submit}
              className="flex-1 max-md:text-[16px] flex gap-1"
            >
              <span>{labels.submit}</span>
              {!!itemsNumber && itemsNumber > 0 && <span>({itemsNumber})</span>}
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </DrawerPortal>
    </Drawer>
  );
}
